import type { Season, SeasonUiType, UpdateSeasonSettingsPayload } from "@/features/seasons/models/season";

export function normalizeSeason(season: Season): Season {
  return {
    ...season,
    allowRosterSelect: Boolean(season.allowRosterSelect),
    allowMatchOfficials: Boolean(season.allowMatchOfficials),
    allowMultipleCaptains: Boolean(season.allowMultipleCaptains),
    matchLockTime: Number(season.matchLockTime) || 0,
  };
}

export function toSeasonSettingsPayload(season: Season): UpdateSeasonSettingsPayload {
  const normalized = normalizeSeason(season);

  return {
    seasonId: normalized.seasonId,
    defaultRoster: normalized.defaultRoster,
    allowRosterSelect: normalized.allowRosterSelect,
    allowMatchOfficials: normalized.allowMatchOfficials,
    allowMultipleCaptains: normalized.allowMultipleCaptains,
    matchLockTime: normalized.matchLockTime,
    uiType: normalized.uiType,
  };
}

export function getSeasonUiTypeOptions(sport: string): { value: SeasonUiType; labelKey: string }[] {
  if (sport === "basketball") {
    return [
      { value: "lite", labelKey: "basketball.ui.lite" },
      { value: "standard", labelKey: "basketball.ui.standard" },
    ];
  }

  if (sport === "hockey") {
    return [
      { value: "outdoor", labelKey: "hockey.ui.outdoor" },
      { value: "indoor", labelKey: "hockey.ui.indoor" },
      { value: "hockey5s", labelKey: "hockey.ui.5s" },
    ];
  }

  if (sport === "handball") {
    return [{ value: "standard", labelKey: "handball.ui.standard" }];
  }

  return [{ value: "standard", labelKey: "sport.ui.standard" }];
}

export function isSeasonUiTypeEditable(sport: string) {
  return sport !== "hockey";
}
